var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSchedule(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 60 60",
    style: {
      enableBackground: "new 0 0 60 60"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M48.38,4.87V0.39h-2.96v4.48h-8.31V0.39h-2.96v4.48h-8.31V0.39h-2.96v4.48h-8.31V0.39h-2.96v4.48H0.35v54.75 h59.29V4.87H48.38z M3.31,56.66V7.83h8.31v3.82h2.96V7.83h8.31v3.82h2.96V7.83h8.31v3.82h2.96V7.83h8.31v3.82h2.96V7.83h8.31v7.8 H12.57v2.96h44.12v38.07H3.31z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35.9,
    y: 27.04,
    className: "st0",
    width: 8.89,
    height: 2.96
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.15,
    y: 41.83,
    className: "st0",
    width: 8.89,
    height: 2.96
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSchedule);
export default __webpack_public_path__ + "static/media/icon_schedule.a6f87944a4ce95f6352f95bdbd65351e.svg";
export { ForwardRef as ReactComponent };